var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DynamicComponent',{attrs:{"edc-id":"polaris-athena","framework":"React","edc-dev":_vm.edcDev,"edcCache":_vm.edcDev,"runtime-did-mounted":"{runtimeDidMounted}","edcQuery":{ abRate: _vm.abRate, mis: _vm.mis }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }